export const ADD_ONS_SEARCH_PARAM = 'addOns';
export const VOYAGE_PROTECTION_ADD_ON_CODE = 'VP';
export const SERVICE_CHARGE_ADD_ON_CODE = 'GRATUITIESPRE';
export const BAR_TAB_ADD_ON_MASK = /^BSL\s[0-9]+$/;

export const ADDONS_WITHOUT_QUANTITIES = [VOYAGE_PROTECTION_ADD_ON_CODE, SERVICE_CHARGE_ADD_ON_CODE];
